"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAYS_TO_EXPIRE_QUOTE = exports.eUnderwriterReviewOptions = exports.eQuoteStatus = void 0;
var eQuoteStatus;
(function (eQuoteStatus) {
    eQuoteStatus["PENDING"] = "pending";
    eQuoteStatus["EXPIRED"] = "expired";
    eQuoteStatus["REJECTED"] = "rejected";
    eQuoteStatus["PURCHASED"] = "purchased";
    eQuoteStatus["CANCELED"] = "canceled";
    eQuoteStatus["UW_REVIEW"] = "uw_review";
    eQuoteStatus["UW_REJECTED"] = "uw_rejected";
})(eQuoteStatus = exports.eQuoteStatus || (exports.eQuoteStatus = {}));
var eUnderwriterReviewOptions;
(function (eUnderwriterReviewOptions) {
    eUnderwriterReviewOptions["APPROVED"] = "Approved";
    eUnderwriterReviewOptions["REJECT"] = "Rejected";
})(eUnderwriterReviewOptions = exports.eUnderwriterReviewOptions || (exports.eUnderwriterReviewOptions = {}));
exports.DAYS_TO_EXPIRE_QUOTE = 30;
//# sourceMappingURL=index.js.map